'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { Alert } from './Alert';
import { FeatherX, FeatherCheckCircle, FeatherAlertCircle, FeatherAlertTriangle, FeatherInfo } from '@subframe/core';
import { IconButton } from './IconButton';
import { Button } from './Button';
import { getErrorMessage } from '@/shared/utils/error';
export interface ToastAction {
  label: string;
  onClick: () => void;
}
export interface ToastProps {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message?: string;
  duration?: number;
  action?: ToastAction;
  onClose: (id: string) => void;
}
const Toast: React.FC<ToastProps> = t0 => {
  const $ = _c(38);
  const {
    id,
    type,
    title,
    message,
    duration: t1,
    action,
    onClose
  } = t0;
  const duration = t1 === undefined ? 5000 : t1;
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);
  let t2;
  if ($[0] !== id || $[1] !== onClose) {
    t2 = () => {
      setIsLeaving(true);
      setTimeout(() => {
        onClose(id);
      }, 300);
    };
    $[0] = id;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClose = t2;
  let t3;
  if ($[3] !== action || $[4] !== handleClose) {
    t3 = () => {
      action?.onClick();
      handleClose();
    };
    $[3] = action;
    $[4] = handleClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleAction = t3;
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const timer = setTimeout(() => setIsVisible(true), 10);
      return () => clearTimeout(timer);
    };
    t5 = [];
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[8] !== duration || $[9] !== handleClose) {
    t6 = () => {
      if (duration > 0) {
        const timer_0 = setTimeout(() => {
          handleClose();
        }, duration);
        return () => clearTimeout(timer_0);
      }
    };
    t7 = [duration, handleClose];
    $[8] = duration;
    $[9] = handleClose;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  const rawMessage = message;
  let t8;
  if ($[12] !== rawMessage) {
    t8 = typeof rawMessage === "string" || rawMessage == null ? rawMessage as string | undefined : getErrorMessage(rawMessage);
    $[12] = rawMessage;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const safeDescription = t8;
  let t9;
  if ($[14] !== type) {
    t9 = () => {
      switch (type) {
        case "success":
          {
            return "success";
          }
        case "error":
          {
            return "error";
          }
        case "warning":
          {
            return "warning";
          }
        case "info":
          {
            return "brand";
          }
        default:
          {
            return "neutral";
          }
      }
    };
    $[14] = type;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const getVariant = t9;
  let t10;
  if ($[16] !== type) {
    t10 = () => {
      switch (type) {
        case "success":
          {
            return <FeatherCheckCircle />;
          }
        case "error":
          {
            return <FeatherAlertCircle />;
          }
        case "warning":
          {
            return <FeatherAlertTriangle />;
          }
        case "info":
          {
            return <FeatherInfo />;
          }
        default:
          {
            return <FeatherInfo />;
          }
      }
    };
    $[16] = type;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const getIcon = t10;
  const t11 = `w-full max-w-sm transform transition-all duration-500 ease-out ${isVisible && !isLeaving ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"} `;
  const t12 = getVariant();
  let t13;
  if ($[18] !== getIcon) {
    t13 = getIcon();
    $[18] = getIcon;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== action || $[21] !== handleAction) {
    t14 = action ? <Button variant="neutral-secondary" size="small" onClick={handleAction}>{action.label}</Button> : null;
    $[20] = action;
    $[21] = handleAction;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FeatherX />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== handleClose) {
    t16 = <IconButton icon={t15} variant="neutral-tertiary" onClick={handleClose} size="small" />;
    $[24] = handleClose;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t14 || $[27] !== t16) {
    t17 = <div className="flex items-center gap-1">{t14}{t16}</div>;
    $[26] = t14;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== safeDescription || $[30] !== t12 || $[31] !== t13 || $[32] !== t17 || $[33] !== title) {
    t18 = <Alert variant={t12} icon={t13} title={title} description={safeDescription} className="border-neutral-100 shadow-xl" actions={t17} />;
    $[29] = safeDescription;
    $[30] = t12;
    $[31] = t13;
    $[32] = t17;
    $[33] = title;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t11 || $[36] !== t18) {
    t19 = <div className={t11}>{t18}</div>;
    $[35] = t11;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
};
export default Toast;